<template>
    <div
        id="modal-move-patient-confirm"
        aria-hidden="true"
        aria-labelledby="modalFillInLabel"
        role="dialog"
        tabindex="-1"
        class="modal modal-default modal-delete"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <header class="modal-header">
                    <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                        <!-- TODO extract svg -->
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.375 0.625C16.875 0.0625 16.0625 0.0625 15.5 0.625L9 7.125L2.5 0.625C1.9375 0.0625 1.125 0.0625 0.625 0.625C0.0625 1.125 0.0625 1.9375 0.625 2.5L7.125 9L0.625 15.5C0.0625 16.0625 0.0625 16.875 0.625 17.375C1.125 17.9375 1.9375 17.9375 2.5 17.375L9 10.875L15.5 17.375C16.0625 17.9375 16.875 17.9375 17.375 17.375C17.9375 16.875 17.9375 16.0625 17.375 15.5L10.875 9L17.375 2.5C17.9375 2 17.9375 1.125 17.375 0.625Z" fill="#676486" />
                        </svg>
                    </button>

                    <template v-if="patient">
                        <strong>{{ __('Patient transfer') }}</strong>
                        <p>{{ __('Do you really want to move this patient to a new dietitian?') }}</p>
                    </template>
                    <template v-else>
                        <strong>{{ __('Transfer of all patients') }}</strong>
                        <p>{{ __('You really want to move all your patients to a new dietitian?') }}</p>
                    </template>
                </header>

                <div class="modal-body">
                    <div class="btn-group">
                        <VButton :label="__('Cancel')" modal-target="dismiss" variant="secondary" />
                        <VButton :label="__('Yes, move')" @onClick="move" type="submit" modal-target="dismiss" color="danger" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        oldCoach: {
            required: true
        },
        newCoach: {
            required: true
        },
        patient: {
            required: false
        }
    },
    mounted() {
        console.log(this.newCoach)
    },
    methods: {
        move() {
            const patient = this.patient ? this.patient : ''

            $('#modal-move-patient form').attr('action', `/coaches/${this.oldCoach}/move-patients/${this.newCoach.id}/${patient}`)
            $('#modal-move-patient form').submit()
        }
    }
}
</script>
